import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuthHandling } from './useAuthhandling';

function Adminregister() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const [formerror, setError] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [user, setUser] = useState({
    username: "",
    password: "",
    email: "",
    usertype: "",
  });

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setUser({ ...user, [name]: value });
  };
  let result = true;
  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.username) {
      errors.username = "username is required!";
    }
    if (!values.password) {
      errors.password = "password is required!";
    }
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }
    if (!values.usertype) {
      errors.location = "usertype is required!";
    }
    return errors;
  };

  const PostData = async (e) => {
    // e.preventDefault();
    const { username, password, email, usertype } = user;
    const ress = validate(user);
    setError(ress);
    setIsSubmit(true);
    if (!ress.email && !ress.username && !ress.password && !ress.usertype) {
      const res = await fetch("https://api.homedotapp.com/adminsignup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: password,
          email: email,
          usertype: usertype,
        }),
      });
      const data = await res.json();
      if (!data) {
        alert("invalid registration");
      } 
      
      else {
        window.alert("successful registration");
      }
    }
  };

  useEffect(() => {
    if (Object.keys(formerror).length === 0 && isSubmit) {
    }
  }, [formerror]);
  return (
    <div>
      <div className="container-scroller">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth px-0">
            <div className="row w-100 mx-0">
              <div className="col-lg-4 mx-auto">
                <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                  <h3 style={{ color: "black" }}>Sign-up</h3>
                  <h6 className="font-weight-light"></h6>
                  <form className="pt-3" onSubmit={PostData}>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control form-control-lg"
                        id="exampleInputEmail1"
                        value={user.email}
                        name="email"
                        onChange={handleInputs}
                        placeholder="Email-Id"
                        style={{ color: "black" }}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        id="exampleInputEmail1"
                        value={user.username}
                        name="username"
                        onChange={handleInputs}
                        placeholder="Username"
                        style={{ color: "black" }}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control form-control-lg"
                        id="exampleInputPassword1"
                        value={user.password}
                        name="password"
                        onChange={handleInputs}
                        placeholder="Password"
                        style={{ color: "black" }}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        id="exampleInputPassword1"
                        value={user.usertype}
                        name="usertype"
                        onChange={handleInputs}
                        placeholder="Enter Usertype(1.superadmin,2.admin)"
                        style={{ color: "black" }}
                      />
                    </div>
                    <div className="mt-3">
                      <button type="submit">sign in</button>
                    </div>
                    <div className="my-2 d-flex justify-content-between align-items-center">
                      <Link to="/" className="auth-link text-black">
                        Login Now?
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Adminregister;
